export default __webpack_public_path__ + "static/media/taskmanager-560-groups.f4acead3.png";